
webpack.register(
    'components/dropdown/dropdown-container/dropdown-container',
    function() {
        return require('components/dropdown/dropdown-container/dropdown-container');
    },
    false
);
webpack.register(
    'components/dropdown/dropdown-item/dropdown-item',
    function() {
        return require('components/dropdown/dropdown-item/dropdown-item');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/dropdown/dropdown-container/dropdown-container'/>\r\n<can-import from='components/dropdown/dropdown-item/dropdown-item'/>\r\n\r\n<div class=\"c-comparison-data\">\r\n    {{#each columns}}\r\n        <div class=\"c-comparison-data__line\">\r\n            <div class=\"c-comparison-data__value {{#if firstPlayer.isBigger}}c-comparison-data__value--bigger{{/if}}\">\r\n                {{firstPlayer.value}}\r\n            </div>\r\n            <div class=\"c-comparison-data__name\">{{title}}</div>\r\n            <div class=\"c-comparison-data__value {{#if secondPlayer.isBigger}}c-comparison-data__value--bigger{{/if}}\">\r\n                {{secondPlayer.value}}\r\n            </div>\r\n        </div>\r\n    {{/each}}\r\n</div>\r\n");